"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgramExpandEnum = exports.ProgramHighlightTypeEnum = exports.PublishingStatusEnum = exports.ProgramSeasonTypesEnum = exports.ProgramTypesEnum = exports.LevelOfPlayEnum = exports.LevelOfPlayNameEnum = exports.ProgramTypeNamesEnum = exports.ProgramTypeNameEnum = void 0;
var ProgramTypeNameEnum;
(function (ProgramTypeNameEnum) {
    ProgramTypeNameEnum["LEAGUE"] = "league";
    ProgramTypeNameEnum["TOURNAMENT"] = "tournament";
    ProgramTypeNameEnum["CLASS"] = "class";
    ProgramTypeNameEnum["CLINIC"] = "clinic";
    ProgramTypeNameEnum["CAMP"] = "camp";
    ProgramTypeNameEnum["LESSON"] = "lesson";
    ProgramTypeNameEnum["CLUB_TEAM"] = "club_team";
})(ProgramTypeNameEnum = exports.ProgramTypeNameEnum || (exports.ProgramTypeNameEnum = {}));
var ProgramTypeNamesEnum;
(function (ProgramTypeNamesEnum) {
    ProgramTypeNamesEnum["LEAGUE"] = "leagues";
    ProgramTypeNamesEnum["TOURNAMENT"] = "tournaments";
    ProgramTypeNamesEnum["CLASS"] = "classes";
    ProgramTypeNamesEnum["CLINIC"] = "clinics";
    ProgramTypeNamesEnum["CAMP"] = "camps";
    ProgramTypeNamesEnum["LESSON"] = "lessons";
    ProgramTypeNamesEnum["CLUB_TEAM"] = "clubTeam";
})(ProgramTypeNamesEnum = exports.ProgramTypeNamesEnum || (exports.ProgramTypeNamesEnum = {}));
var LevelOfPlayNameEnum;
(function (LevelOfPlayNameEnum) {
    LevelOfPlayNameEnum["BEGINNER"] = "beginner";
    LevelOfPlayNameEnum["INTERMEDIATE"] = "intermediate";
    LevelOfPlayNameEnum["ADVANCED"] = "advanced";
    LevelOfPlayNameEnum["SEMIPRO"] = "semipro";
    LevelOfPlayNameEnum["SPECTATOR"] = "spectator";
})(LevelOfPlayNameEnum = exports.LevelOfPlayNameEnum || (exports.LevelOfPlayNameEnum = {}));
var LevelOfPlayEnum;
(function (LevelOfPlayEnum) {
    LevelOfPlayEnum[LevelOfPlayEnum["BEGINNER"] = 1] = "BEGINNER";
    LevelOfPlayEnum[LevelOfPlayEnum["INTERMEDIATE"] = 2] = "INTERMEDIATE";
    LevelOfPlayEnum[LevelOfPlayEnum["ADVANCED"] = 3] = "ADVANCED";
    LevelOfPlayEnum[LevelOfPlayEnum["SEMIPRO"] = 4] = "SEMIPRO";
    LevelOfPlayEnum[LevelOfPlayEnum["SPECTATOR"] = 5] = "SPECTATOR";
})(LevelOfPlayEnum = exports.LevelOfPlayEnum || (exports.LevelOfPlayEnum = {}));
var ProgramTypesEnum;
(function (ProgramTypesEnum) {
    ProgramTypesEnum[ProgramTypesEnum["LEAGUE"] = 0] = "LEAGUE";
    ProgramTypesEnum[ProgramTypesEnum["TOURNAMENT"] = 1] = "TOURNAMENT";
    ProgramTypesEnum[ProgramTypesEnum["CLASS"] = 2] = "CLASS";
    ProgramTypesEnum[ProgramTypesEnum["CLINIC"] = 3] = "CLINIC";
    ProgramTypesEnum[ProgramTypesEnum["CAMP"] = 4] = "CAMP";
    ProgramTypesEnum[ProgramTypesEnum["LESSON"] = 5] = "LESSON";
    ProgramTypesEnum[ProgramTypesEnum["CLUB_TEAM"] = 6] = "CLUB_TEAM";
    ProgramTypesEnum[ProgramTypesEnum["LEAGUE_V2"] = 10] = "LEAGUE_V2";
    ProgramTypesEnum[ProgramTypesEnum["TOURNAMENT_V2"] = 11] = "TOURNAMENT_V2";
})(ProgramTypesEnum = exports.ProgramTypesEnum || (exports.ProgramTypesEnum = {}));
var ProgramSeasonTypesEnum;
(function (ProgramSeasonTypesEnum) {
    ProgramSeasonTypesEnum[ProgramSeasonTypesEnum["ROUND_ROBIN"] = 1] = "ROUND_ROBIN";
    ProgramSeasonTypesEnum[ProgramSeasonTypesEnum["BRACKETS"] = 2] = "BRACKETS";
    ProgramSeasonTypesEnum[ProgramSeasonTypesEnum["CAMP_CLINIC_CLASS"] = 3] = "CAMP_CLINIC_CLASS";
})(ProgramSeasonTypesEnum = exports.ProgramSeasonTypesEnum || (exports.ProgramSeasonTypesEnum = {}));
var PublishingStatusEnum;
(function (PublishingStatusEnum) {
    PublishingStatusEnum[PublishingStatusEnum["DRAFT"] = 1] = "DRAFT";
    PublishingStatusEnum[PublishingStatusEnum["PUBLISHED"] = 2] = "PUBLISHED";
    PublishingStatusEnum[PublishingStatusEnum["CLOSED"] = 3] = "CLOSED";
    PublishingStatusEnum[PublishingStatusEnum["CANCELLED"] = 4] = "CANCELLED";
    PublishingStatusEnum[PublishingStatusEnum["ARCHIVE"] = 5] = "ARCHIVE";
    PublishingStatusEnum[PublishingStatusEnum["UNPUBLISHED"] = 6] = "UNPUBLISHED";
})(PublishingStatusEnum = exports.PublishingStatusEnum || (exports.PublishingStatusEnum = {}));
var ProgramHighlightTypeEnum;
(function (ProgramHighlightTypeEnum) {
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["OTHER"] = 1] = "OTHER";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["MINAGE"] = 2] = "MINAGE";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["MAXAGE"] = 3] = "MAXAGE";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["GENDER"] = 4] = "GENDER";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["LEVELOFPLAY"] = 5] = "LEVELOFPLAY";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["GAMESSEASON"] = 6] = "GAMESSEASON";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["MINWEEK"] = 7] = "MINWEEK";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["SURFACE"] = 8] = "SURFACE";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["FORMAT"] = 9] = "FORMAT";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["PLAYERS_PER_TEAM"] = 10] = "PLAYERS_PER_TEAM";
    ProgramHighlightTypeEnum[ProgramHighlightTypeEnum["MATCH_LENGTH"] = 12] = "MATCH_LENGTH";
})(ProgramHighlightTypeEnum = exports.ProgramHighlightTypeEnum || (exports.ProgramHighlightTypeEnum = {}));
var ProgramExpandEnum;
(function (ProgramExpandEnum) {
    ProgramExpandEnum["SESSIONS"] = "sessions";
    ProgramExpandEnum["SESSIONS_REQUIRED_PRODUCTS"] = "sessions.requiredProducts";
    ProgramExpandEnum["SESSIONS_PRODUCTS"] = "sessions.products";
    ProgramExpandEnum["SESSIONS_PRODUCTS_PRICES"] = "sessions.products.prices";
    ProgramExpandEnum["SESSIONS_PRODUCTS_REQUIRED_PRODUCTS"] = "sessions.products.requiredProducts";
    ProgramExpandEnum["SESSIONS_PRODUCTS_ENTITLEMENT_DISCOUNTS"] = "sessions.products.entitlementDiscounts";
})(ProgramExpandEnum = exports.ProgramExpandEnum || (exports.ProgramExpandEnum = {}));
//# sourceMappingURL=program.enums.js.map